import React from "react";
import { FormattedMessage } from "react-intl";
import { Menu } from "semantic-ui-react";
import { includes } from "lodash";
import { NavLinkProps } from "../types";
import * as requests from "./requests";

import messages from "./messages";

const links: NavLinkProps[] = [
  {
    to: "/mismatched",
    children: (
      <Menu.Item>
        <FormattedMessage {...messages.mismatched} />
      </Menu.Item>
    ),
  },
  {
    to: "/misbilled",
    children: (
      <Menu.Item>
        <FormattedMessage {...messages.misbilled} />
      </Menu.Item>
    ),
  },
];

// Get a setting (by key) from window.APP_CONFIG (from config.js).
// If the setting does not exist, return an optional defaultValue or undefined.
function getAppConfigSetting(key: string, defaultValue?: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const config = window.appConfig;
  let value;
  if (config && key in config) {
    // config keys are allowed to have mustache template values referencing APP_CONFIG
    value = config[key];
  }
  return value === undefined ? defaultValue : value;
}

export const isApexInternalApp = () =>
  includes(getAppConfigSetting("appsUrl"), "apps.apexclearing.local");

export const offset = new Date().getTimezoneOffset() * 60000;
export const timeNow = new Date(Date.now() - offset)
  .toISOString()
  .substring(0, 19);
export const startOfDay = `${new Date()
  .toISOString()
  .substring(0, 11)}00:00:00`;

export * from "./intlTestHelpers";

export { requests, links, getAppConfigSetting };
